import { reactive, ref, toRefs, computed, nextTick } from 'vue'
import moment from 'moment'
import { isArray } from '@/common/js/utils.js'
import { pick, groupBy, clone } from '@/common/js/just.js'
import { Message } from 'view-design'
import { BRAND_ENUM, PAGE_TYPES } from '@/views/create/gdt/model/creative-const.js'
import { AD_MARKETING_SCENE, GDT_MENU_ID } from '@/views/create/gdt/model/project-const.js'
import {
  makeV3InnerPlanParams,
  makeV3CreativeParams,
  makeV3OuterPlanParams,
  makeSearchAdParams
} from '@/views/create/gdt/model/distribute-form.js'

import { submitTencentV3Plans, submitTencentSearchAdPlans } from '@/api/tencentada.model.js'
import { addtemplate } from '@/api/ptom.data.model'

import { useGdtCreativeComputes } from '../hooks/utils/creative.js'
import { getDefaultCheckStates } from '../components/preview-table/hooks/usePlanPreview.js'
const targetingPlanParamsKeys = [
  'siteSet',
  'exploration_strategy',
  'priority_site_set',
  'scene_spec',
  'wechat_scene',
  'wechat_position',
  'wechatPostion',
  'payScene',
  'miniGame',
  'flow_optimization_enabled',
  'excludeUnionType',
  'displaySceneType',
  'officialAccountMediaCate',
  'automatic_site_enabled',
  'wechat_channels',
  'wechatChannels',
  'pc_scene',
  'pcScene',
  'qbsearch_scene',
  'qbSearchScene',
  'wechat_search_scene',
  'wechatSearchScene',
  'smart_targeting_mode'
]
export const usePlanDistribute = (configForm) => {
  const formColRefs = ref([])
  const previewModel = reactive({
    planParams: null,
    duplicateNameError: '',
    activeAccount: '',
    submitLoading: false,
    submitConfirmModal: false,
    submitSaveTemplateName: '',
    // 根据账号分组的预览表格状态表单，管理表头的全局switch状态
    //  {
    //    [account.id]: {
    //     projectSwitch: true,
    //     planSwitch: true
    //     isCheckAll: true
    //   }
    //  }
    tableStatesForm: {},
    previewOriginData: {},
    targetPackages: [],
    creativeGroups: []
  })
  const tableData = computed({
    get() {
      return previewModel.previewOriginData[previewModel.activeAccount] || []
    },
    set(data) {
      previewModel.previewOriginData[previewModel.activeAccount] = data
    }
  })

  const updateTableData = (data) => {
    tableData.value = data
  }
  const updateTableForm = (data) => {
    previewModel.tableStatesForm[previewModel.activeAccount] = data
  }

  const tableFormFilteredByAccount = computed({
    get() {
      return previewModel.tableStatesForm[previewModel.activeAccount]
    },
    set(data) {
      previewModel.tableStatesForm[previewModel.activeAccount] = data
    }
  })

  const onAcitveAccountChange = (accountId) => {
    previewModel.activeAccount = accountId
  }

  const onPlansValidate = async () => {
    const { planForm, targetings, creativeForm, creatives, descriptions, landingPages, accounts } = configForm.value
    if (Object.keys(planForm).length === 0) {
      Message.warning('请先配置计划信息')
      return Promise.reject(new Error('请先配置计划信息'))
    }
    const targetingCount = targetings.length
    if (targetingCount === 0) {
      Message.warning('请先配置定向信息')
      return Promise.reject(new Error('请先配置定向信息'))
    }

    if (targetingCount > 0) {
      const smartVersionTagetings = targetings.filter((t) => t.adMarketingScene === '智投定向')
      const searchVersionTagetings = targetings.filter((t) => t.adMarketingScene === '搜索广告定向')
      const v3VersionTagetings = targetings.filter((t) => t.adMarketingScene === '3.0广告定向')
      let msg = ''
      switch (planForm.ad_marketing_scene) {
        case AD_MARKETING_SCENE.VERSION_SMART:
          if (smartVersionTagetings.length < targetingCount) {
            msg = '非智投计划定向不能用于投放'
          }

          if (smartVersionTagetings.some((t) => !t.targetingParamJson.automatic_site_enabled)) {
            msg = '智投计划只能使用自动版位定向'
          }
          break

        case AD_MARKETING_SCENE.VERSION_SEARCH:
          if (searchVersionTagetings.length < targetingCount) {
            msg = '非搜索计划定向不能用于投放'
          }
          break

        case AD_MARKETING_SCENE.VERSION_3:
          if (v3VersionTagetings.length < targetingCount) {
            msg = '非腾讯v3定向不能用于投放'
          }
          break

        default:
          break
      }

      if (msg) {
        Message.warning(msg)
        return Promise.reject(new Error(msg))
      }
    }

    if (Object.keys(creativeForm).length === 0) {
      Message.warning('请先配置创意信息')
      return Promise.reject(new Error('请先配置创意信息'))
    }
    if (creatives.length === 0) {
      Message.warning('请先配置创意素材')
      return Promise.reject(new Error('请先配置创意素材'))
    }
    if (descriptions.length === 0) {
      Message.warning('请先配置文案包')
      return Promise.reject(new Error('请先配置文案包'))
    }

    if (!landingPages.length) {
      Message.warning('请先配置品牌形象及落地页')
      return Promise.reject(new Error('请先配置品牌形象及落地页'))
    }
    const { switch: mini_card_link_switch, page_type: mini_card_page_type } = creativeForm.components.mini_card_link || {}
    const { switch: text_link_switch, page_type: text_link_page_type } = creativeForm.components.text_link || {}
    const { floating_zone_switch } = creativeForm.components.floating_zone || {}
    if (floating_zone_switch) {
      if (landingPages.some((i) => i.profile.brandType !== BRAND_ENUM.CHANNEL)) {
        Message.warning('浮层卡片组件品牌形象必选视频号')
        return Promise.reject(new Error('浮层卡片组件品牌形象必选视频号'))
      }
    }

    const accountIds = accounts.map((ac) => ac.id)

    const { VERSION_SMART, VERSION_3 } = AD_MARKETING_SCENE
    const pageTypeValidator = (pageArr) => {
      const officalPageItem = pageArr.find((p) => p.pageType === 5 && p.page.page_id)
      if (!officalPageItem) return '须配置至少一个官方落地页'
      return true
    }
    for (let i = 0; i < landingPages.length; i++) {
      const page = landingPages[i]
      const pageArr = page.landingPages.info || []
      // 已选账号不在配置落地页中，跳过
      if (!accountIds.includes(page.accountId)) continue

      // v3和智投才验证mini_card_link_switch、text_link_switch
      if ([VERSION_SMART, VERSION_3].includes(planForm.ad_marketing_scene)) {
        // 是否开启了图文链接或朋友圈文字链、如果开启了需要验证跳转落地页与落地页是否匹配
        if (mini_card_link_switch) {
          // 是否配置官方了落地页
          if (mini_card_page_type === PAGE_TYPES.OFFICIAL) {
            const msg = pageTypeValidator(pageArr)
            if (msg?.length) {
              Message.warning(`账号：${page.accountName}${msg}`)
              return Promise.reject(new Error(msg))
            }
          }
        }

        if (text_link_switch) {
          if (text_link_page_type === PAGE_TYPES.OFFICIAL) {
            const msg = pageTypeValidator(pageArr)
            if (msg?.length) {
              Message.warning(`账号：${page.accountName}${msg}`)
              return Promise.reject(new Error(msg))
            }
          }
        }
      }

      if (!pageArr?.length) {
        Message.warning(`账号：${page.accountName}须配置落地页`)
        return Promise.reject(new Error('请先配置落地页'))
      }

      const info = Object.values(page.profile.info)
      if (!info?.length) {
        Message.warning(`账号：${page.accountName}须配置品牌形象`)
        return Promise.reject(new Error('请先配置品牌形象'))
      }
    }

    try {
      for (let i = 0; i < formColRefs.value.length; i++) {
        const ref = formColRefs.value[i]
        if (ref) {
          await ref.validate()
        }
      }
      // 每次预览时清空重名错误提示
      previewModel.duplicateNameError = ''
      return Promise.resolve()
    } catch (e) {
      console.log('onPlansPreview valid eeeeeee output: ', e)
      return Promise.reject(new Error(JSON.stringify({ index: e.message })))
    }
  }

  /**
   * @description: 生成计划预览表格数据
   * @return {*}
   */
  const onPlansPreview = async () => {
    previewModel.activeAccount = configForm.value.accounts[0].id
    // 获取全部的定向包，用于预览表格批量修改
    previewModel.targetPackages = buildTargetingBasedPlanRows(configForm.value).map((p) => p.target)
    previewModel.creativeGroups = configForm.value.creatives
    const { isWxGamePlayable } = useGdtCreativeComputes(configForm.value.creativeForm)

    const { adNumber, accountAllocation, projectAllocation } = configForm.value.template
    // 广告数量：账号 × 定向包数 × 创意组数
    if (adNumber === 1) {
      // 以定向包为基准，创建广告计划
      let planList = buildTargetingBasedPlanRows(configForm.value)
      // 分配创意
      planList = multiplyMaterials(planList, configForm.value)
      // 分配文案
      planList = appendDescriptions(planList, configForm.value)

      // 根据定向包分配项目，一个定向生成一个项目
      const planGroups = groupBy(planList, (plan) => plan.target.targetingId)

      // 多账号广告分配：全部复制
      if (accountAllocation === 1) {
        previewModel.previewOriginData = distributeByDupItemToAccount(Object.values(planGroups), configForm.value)
      }
    }

    if (adNumber === 2) {
      // 以定向包为基准，创建广告计划
      let planList = buildTargetingBasedPlanRows(configForm.value)

      planList = multiplyMaterials(planList, configForm.value)
      planList = appendDescriptions(planList, configForm.value)

      // 多账号：按定向分配
      if (accountAllocation === 2) {
        previewModel.previewOriginData = distributeByTargeting(planList, configForm.value)
      }
    }

    // 最终提交的计划数 = 创意组数
    if (adNumber === 3) {
      if (accountAllocation === 3) {
        const { accounts, targetings, creatives } = configForm.value
        const creativeCounts = creatives.length
        if (accounts.length * targetings.length > creativeCounts) {
          const msg = `创意组数不能小于${accounts.length * targetings.length}个`
          Message.warning(msg)
          return Promise.reject(new Error(msg))
        }
      }

      // 以创意为基准，创建广告计划
      let planList = buildCreativeBasedPlanRow(configForm.value)
      planList = appendDescriptions(planList, configForm.value)
      previewModel.previewOriginData = distributeByCreativeGroup(accountAllocation, planList, configForm.value)
    }

    for (const i in previewModel.previewOriginData) {
      const tableData = previewModel.previewOriginData[i].map((tableRow) => {
        return {
          ...tableRow,
          // 初始化预览每行的check状态
          ...getDefaultCheckStates()
        }
      })
      previewModel.previewOriginData[i] = tableData
    }

    nextTick(() => {
      document.querySelector('.preview-table').scrollIntoView({ block: 'start', behavior: 'smooth' })
    })
  }

  /**
   * @description: 重复广告名称检测
   * @return {*}
   */
  function duplicateNameValidate() {
    previewModel.duplicateNameError = ''
    const planData = Object.values(previewModel.previewOriginData).flat()
    // 所有的广告用permanent_plan_name计划名称进行分组
    const groupedPlan = groupBy(planData, (plan) => plan.permanent_plan_name)
    // 最终只需要每个组的第一个计划用来作比对
    const items = Object.values(groupedPlan).map((i) => i[0])
    // 已存在的广告名称
    const seen = new Set()
    // 重复的计划
    const duplicates = new Set()

    items.forEach((i) => {
      const project_name = i.plan.project_name
      if (seen.has(project_name)) {
        duplicates.add(i)
      } else {
        seen.add(project_name)
      }
    })

    if (duplicates.size > 0) {
      const [errorRow] = [...duplicates]
      previewModel.duplicateNameError = errorRow.plan.project_name

      nextTick(() => {
        document.querySelector('.preview-table .project-name-error-msg').scrollIntoView({ block: 'center', behavior: 'smooth' })
      })
      return Promise.reject(new Error('存在重复的计划名称'))
    }

    return Promise.resolve()
  }

  const onSubmitCancel = () => {
    previewModel.submitConfirmModal = false
    previewModel.submitSaveTemplateName = ''
  }

  const onSubmitValidate = async () => {
    try {
      await duplicateNameValidate()

      const planData = Object.values(previewModel.previewOriginData).flat()
      for (const plan of planData) {
        const { project_name, daily_budget, budget, ad_marketing_scene } = plan.plan
        if (!project_name.trim()) {
          throw new Error('计划名称不能为空')
        }

        if (ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH) {
          if (budget === 1) {
            if (!daily_budget.trim()) {
              throw new Error('搜索计划日预算不能为空')
            }
          }
        }
      }
    } catch (e) {
      return Message.warning(e.message)
    }

    const regionList = []
    let errorRow = null
    let errorRowIndex = -1
    let tableRows = []
    const tableData = Object.values(previewModel.previewOriginData)

    try {
      tableRows = tableData
        .flat()
        // 过滤未勾选的广告
        .filter((row) => row.helper.isCheck)
        .map((row, index) => {
          errorRow = row
          errorRowIndex = index
          const targetingPlanParams = pick(row.target, targetingPlanParamsKeys)
          // 使用定向包内的定向参数覆盖plan，与旧版3.0保持一致；
          row.plan = {
            ...row.plan,
            ...targetingPlanParams
          }

          const inner_plan_params = makeV3InnerPlanParams(row)
          const outer_plan_params = makeV3OuterPlanParams(row, regionList)
          const creative_params = makeV3CreativeParams(row)

          if (row.target.targetingId) {
            inner_plan_params.caohuaTargetingId = row.target.targetingId
          }

          const { planSwitch, projectSwitch } = previewModel.tableStatesForm[row.ad_account_id]
          outer_plan_params.operation = projectSwitch ? 'enable' : 'disable'
          creative_params.operation = planSwitch ? 'enable' : 'disable'

          const params = {
            ad_account_id: row.ad_account_id,
            inner_plan_params,
            creative_params,
            outer_plan_params
          }

          // 搜索广告计划参数
          if (outer_plan_params.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH) {
            return makeSearchAdParams(row, params)
          }

          return params
        })
      console.log('submit tableRows output: ', tableRows)
    } catch (e) {
      console.log('eeeeee output: ', e)
      Message.warning(e.message)
      previewModel.activeAccount = errorRow.ad_account_id

      return
    }

    const planParams = {
      batch_task_type: 1,
      planlist: tableRows
    }

    previewModel.planParams = planParams

    previewModel.submitConfirmModal = true
  }

  /**
   * @description: 确认提交
   * @return {*}
   */
  const onSubmitConfirm = async (saveTemplateData) => {
    previewModel.submitLoading = true

    try {
      const [firstRow] = previewModel.planParams.planlist
      const isSearchAd = !!firstRow.campaign_params
      const data = isSearchAd
        ? await submitTencentSearchAdPlans(previewModel.planParams)
        : await submitTencentV3Plans(previewModel.planParams)
      if (data) {
        Message.success('提交成功！')

        if (saveTemplateData?.menuId) {
          await addtemplate(saveTemplateData)
        }

        // 用于清空品牌形象落地页
        // eventBus.$emit('gdtTemplateAccountChange')

        previewModel.previewOriginData = {}
      }

      previewModel.submitLoading = false
      onSubmitCancel()
    } catch (e) {
      previewModel.submitLoading = false
    }
  }

  const saveTemplateSubmit = async () => {
    try {
      const data = {
        menuId: GDT_MENU_ID,
        name: previewModel.submitSaveTemplateName.trim(),
        conditionInfo: configForm.value
      }
      onSubmitConfirm(data)
    } catch (e) {
      console.log('saveTemplateSubmit eeeeeeeeeee output: ', e)
    }
  }

  return {
    ...toRefs(previewModel),
    formColRefs,
    tableData,
    updateTableData,
    updateTableForm,
    onAcitveAccountChange,
    tableFormFilteredByAccount,
    onPlansValidate,
    onPlansPreview,
    onSubmitCancel,
    duplicateNameValidate,
    onSubmitValidate,
    onSubmitConfirm,
    saveTemplateSubmit
  }
}

function buildCreativeBasedPlanRow(configForm) {
  const { creatives } = configForm

  const getPlan = () => {
    return {
      helper: {
        // 预览表格是否勾选
        isCheck: true
      },
      plan: clone(configForm.planForm),
      bid: clone(configForm.budgetForm),
      // 创意信息
      creative: clone(configForm.creativeForm),
      // 包含全部账号配置的落地页和品牌形象信息
      langdingpages: clone(configForm.landingPages)
    }
  }

  return creatives.map((creative) => appendMaterialImageList(getPlan(), creative))
}

/**
 * @description: 以定向包为基准创建广告计划
 * @return {*}
 */
function buildTargetingBasedPlanRows(configForm) {
  const { targetings } = configForm

  const planList = targetings.map((t) => {
    const target = {
      ...t.targetingParamJson,
      accountId: Number(t.accountIds),
      targetingId: t.targetingId,
      name: t.targetingName
    }

    return {
      helper: {
        // 预览表格是否勾选
        isCheck: true
      },
      plan: clone(configForm.planForm),
      bid: clone(configForm.budgetForm),
      target: clone(target),
      // 创意信息
      creative: clone(configForm.creativeForm),
      // 包含全部账号配置的落地页和品牌形象信息
      langdingpages: clone(configForm.landingPages)
    }
  })

  return planList
}

/**
 * @description: 创意参数填充素材数据，包括图片、视频、音频；添加批量复制流程回显创意的辅助参数、添加广告计划预览创意的辅助参数
 * @param {*} plan
 * @param {*} creative
 * @return {*}
 */
export function appendMaterialImageList(plan, creative) {
  const dupPlan = clone(plan)
  const { image, video, image_list } = creative.selectedMaterials
  dupPlan.creative.groupName = creative.creative_name
  dupPlan.creative.selectedAssets = creative.selectedMaterials

  // 用于素材表格预览
  dupPlan.helper.preview_list = []

  // 图片
  if (image?.length) {
    for (let j = 0; j < image.length; j++) {
      const imageItem = image[j]

      dupPlan.helper.preview_list.push({
        // 添加地址和横版竖版信息，用于表格显示
        name: imageItem.name,
        badge: '图片',
        url: imageItem.preview_url,
        vertical: imageItem.height > imageItem.width
      })
    }
  }
  if (image_list?.length) {
    for (let j = 0; j < image_list.length; j++) {
      const imageItem = image_list[j]
      dupPlan.helper.preview_list.push({
        // 添加地址和横版竖版信息，用于表格显示
        name: imageItem.name,
        badge: '组图',
        url: imageItem.preview_url,
        vertical: imageItem.height > imageItem.width
      })
    }
  }

  if (video?.length) {
    // 视频
    for (let j = 0; j < video.length; j++) {
      const videoItem = video[j]

      dupPlan.helper.preview_list.push({
        // 添加地址和横版竖版信息，用于表格显示
        name: videoItem.name,
        badge: '视频',
        url: videoItem.preview_url, // 视频封面图
        vertical: videoItem.height > videoItem.width
      })
    }
  }

  return dupPlan
}

/**
 * @description: 为基础计划参数乘以素材数，得到计划数
 * @return {*}
 */
function multiplyMaterials(planList, { creatives }) {
  let newPlanList = []

  for (let i = 0; i < creatives.length; i++) {
    const creative = creatives[i]
    const newList = planList.map((row) => {
      const dupPlan = appendMaterialImageList(row, creative)
      return dupPlan
    })

    newPlanList = newPlanList.concat(newList)
  }

  return newPlanList
}

/**
 * @description: 为计划分配文案参数
 * @return {*}
 */
function appendDescriptions(planList, { descriptions }) {
  // 遍历文案包，为每个计划设置文案
  const newList = planList.map((plan, index) => {
    const dupPlan = clone(plan)
    const descIndex = index % descriptions.length
    // 文案最多3条
    const descItems = descriptions[descIndex]?.content?.slice(0, 3) || []
    const packName = descriptions[descIndex]?.packName

    // 用于预览表格显示
    dupPlan.helper.title_pack_name = packName
    if (descItems?.length) {
      dupPlan.creative.description = descItems.map((content) => ({ content }))
    }

    return dupPlan
  })
  return newList
}

/**
 * @description: 分配账号下的计划，根据定向分配到每个账号：每个账号下的定向包都是相同的
 */
function distributeByTargeting(planList, { accounts }) {
  const plansGroupByAccount = {}

  let planListGroupByTargeting = groupBy(planList, (plan) => plan.target.name)
  planListGroupByTargeting = Object.values(planListGroupByTargeting)

  if (planListGroupByTargeting.length > accounts.length) {
    for (let i = 0; i < planListGroupByTargeting.length; i++) {
      const account = accounts[i % accounts.length]
      const group = planListGroupByTargeting[i]
      const targetingId = group[0].target.targetingId

      if (!plansGroupByAccount[targetingId]) {
        plansGroupByAccount[targetingId] = []
      }
      plansGroupByAccount[targetingId] = plansGroupByAccount[targetingId].concat(
        group.map((plan) => ({ ...plan, ad_account_id: account.id, ad_account_simple_name: account.adAccountSimpleName }))
      )
    }
  } else {
    for (let i = 0; i < accounts.length; i++) {
      const account = accounts[i]
      const accountId = account.id
      const plans = planListGroupByTargeting[i % planListGroupByTargeting.length]
      if (!plansGroupByAccount[accountId]) {
        plansGroupByAccount[accountId] = []
      }
      plansGroupByAccount[accountId] = plansGroupByAccount[accountId].concat(
        plans.map((plan) => ({ ...plan, ad_account_id: account.id, ad_account_simple_name: account.adAccountSimpleName }))
      )
    }
  }

  // 再次根据账号分组
  const newPlanList = setProjectInfo(Object.values(plansGroupByAccount))
  const newPlansGroupByAccount = {}

  for (let i = 0; i < newPlanList.length; i++) {
    const plan = newPlanList[i]
    if (!newPlansGroupByAccount[plan.ad_account_id]) {
      newPlansGroupByAccount[plan.ad_account_id] = []
    }
    // 落地页和品牌形象跟账号走，为每个账号找到对应配置好的落地页
    const newPlan = appendLandingPagesByAccount(plan, plan.ad_account_id)

    newPlansGroupByAccount[newPlan.ad_account_id] = newPlansGroupByAccount[newPlan.ad_account_id].concat(newPlan)
  }

  return newPlansGroupByAccount
}

function appendLandingPagesByAccount(plan, accountId) {
  const page = plan?.langdingpages.find((page) => page.accountId === accountId)
  if (page) {
    const { profile, landingPages } = page
    plan.creative.pageInfo = isArray(landingPages.info) ? landingPages.info : []

    if (profile.brandType === BRAND_ENUM.CHANNEL) {
      plan.creative.components.wechat_channels = {
        ...plan.creative.components.wechat_channels,
        channelInfo: profile.info
      }
      plan.creative.components.brand = {
        brandType: profile.brandType
      }
    } else {
      plan.creative.components.brand = {
        profileInfo: profile.info,
        brandType: profile.brandType,
        brandInfo: profile.info,
        officialAccountInfo: profile.info
      }
    }
  }
  return plan
}

/**
 * @description: 生成定向包全复制到到账号的组合
 *  分配示例：
        账号 定向包 创意组
        A1   B1    C1
        A1   B2    C2
        A1   B3    C3
        A1   B4    C4
        A2   B1    C5
        A2   B2    C6
        A2   B3    C7
        A2   B4    C8
        A1   B1    C9
        A1   B2    C10
 * @return {*}
 */

function generatePlanCombinationsByDuplicate(planList, accounts, targetings) {
  const combinations = []

  for (let i = 0; i < planList.length; i++) {
    // 计算当前应该使用哪个账号
    // 每个账号连续使用所有定向包后才换下一个账号
    const accountGroupIndex = Math.floor(i / targetings.length) % accounts.length
    const account = accounts[accountGroupIndex]

    // 计算当前应该使用哪个定向包
    // 在每个账号内，定向包按顺序循环使用
    const targetingIndex = i % targetings.length
    const targeting = targetings[targetingIndex]

    const combination = {
      account,
      targeting,
      plan: planList[i]
    }

    combinations.push(combination)
  }
  return combinations
}

/**
 * @description: 生成定向包循环分配到账号的组合
 分配示例：
        账号 定向包 创意组
        A1    B1    C1
        A2    B2    C2
        A1    B3    C3
        A2    B4    C4
        A1    B5    C5
        A1    B1    C6
        A2    B2    C7
        A1    B3    C8
 * @param {*} planList
 * @param {*} accounts
 * @param {*} targetings
 * @return {*}
 */
function generatePlanCombinations(planList, accounts, targetings) {
  const combinations = []

  // 首先创建账号和定向包的基础组合
  const baseMapping = []
  let needleIndex = 0

  if (targetings.length > accounts.length) {
    // 创建初始的账号-定向包基准映射
    for (let i = 0; i < targetings.length; i++) {
      baseMapping.push({
        account: accounts[needleIndex % accounts.length],
        targeting: targetings[i]
      })
      needleIndex++
    }
  } else {
    // 创建初始的账号-账号基准映射
    for (let i = 0; i < accounts.length; i++) {
      baseMapping.push({
        account: accounts[i],
        targeting: targetings[needleIndex % targetings.length]
      })
      needleIndex++
    }
  }

  // 为每个创意组生成完整组合
  for (let i = 0; i < planList.length; i++) {
    // 使用baseMapping中的组合，循环使用
    const baseCombination = baseMapping[i % baseMapping.length]
    const combination = {
      account: baseCombination.account,
      targeting: baseCombination.targeting,
      plan: planList[i]
    }
    combinations.push(combination)
  }

  return combinations
}

/**
 * @description: 定向包循环分配到账号
 * @param {*} type
 * @param {*} planList
 * @param {*} accounts
 * @param {*} targetings
 * @return {*}
 */
function distributeByCreativeGroup(type, planList, { accounts, targetings }) {
  // 生成数据
  const results =
    type === 2
      ? generatePlanCombinations(planList, accounts, targetings)
      : generatePlanCombinationsByDuplicate(planList, accounts, targetings)
  const newPlanList = []
  const projectNames = {}
  const planNames = {}
  for (let i = 0; i < results.length; i++) {
    const { account, targeting, plan } = results[i]
    const dupPlan = clone(plan)

    const target = {
      ...targeting.targetingParamJson,
      accountId: Number(targeting.accountIds),
      targetingId: targeting.targetingId,
      name: targeting.targetingName
    }
    dupPlan.ad_account_id = account.id
    dupPlan.ad_account_simple_name = account.adAccountSimpleName
    dupPlan.target = target

    // 落地页和品牌形象跟账号走，为每个账号找到对应配置好的落地页
    const newPlan = appendLandingPagesByAccount(dupPlan, account.id)

    const key = `${newPlan.ad_account_id}_${newPlan.target.name}`
    const projectIndex = i + 1
    const name = newPlan.plan.project_name
    const permanent_plan_name = `${name}_${projectIndex}`
    const project_name = replaceDynamicValue(name, newPlan.target.name, newPlan.ad_account_simple_name).concat(`_${projectIndex}`)

    // 为同账号同定向的计划保存permanent_plan_name，permanent_plan_name用于合并单元格
    if (!planNames[key]) {
      planNames[key] = permanent_plan_name
    }
    // 为同账号同定向的计划保存project_name
    if (!projectNames[key]) {
      projectNames[key] = project_name
    }

    newPlan.permanent_plan_name = planNames[key]
    newPlan.plan.project_name = projectNames[key]
    newPlanList.push(newPlan)
  }

  // 再次根据账号分组
  const newPlansGroupByAccount = {}

  for (let i = 0; i < newPlanList.length; i++) {
    const plan = newPlanList[i]
    if (!newPlansGroupByAccount[plan.ad_account_id]) {
      newPlansGroupByAccount[plan.ad_account_id] = []
    }

    // 最终根据账号分配的数组项需要根据permanent_plan_name进行排序， 使相同permanent_plan_name的计划排在一起，否则在表格中合并单元格会错乱
    newPlansGroupByAccount[plan.ad_account_id] = newPlansGroupByAccount[plan.ad_account_id].concat(plan).sort((a, b) => {
      return a.permanent_plan_name.localeCompare(b.permanent_plan_name)
    })
  }
  return newPlansGroupByAccount
}

/**
 * @description: 分配账号下的计划，每个账号的计划全部相同
 * @return {*}
 */
function distributeByDupItemToAccount(planGroups, { accounts }) {
  const plansGroupByAccount = {}

  for (let i = 0; i < accounts.length; i++) {
    const account = accounts[i]

    planGroups = planGroups.map((group) => {
      return group.map((plan) => {
        return { ...plan, ad_account_id: account.id, ad_account_simple_name: account.adAccountSimpleName }
      })
    })
    const planList = setProjectInfo(planGroups, i * planGroups.length)

    plansGroupByAccount[account.id] = planList.map((plan) => {
      // 落地页和品牌形象跟账号走，为每个账号找到对应配置好的落地页
      const newPlan = appendLandingPagesByAccount(plan, account.id)

      return { ...newPlan }
    })
  }

  return plansGroupByAccount
}

/**
 * @description: 根据项目名称对广告分组
 * @param {*} planGroups
 * @param {*} projectIndex 为确保每个项目名称唯一，为项目名称添加递增索引
 * @param {*} planIndex 为确保每个项目下的计划名称唯一，为计划名称添加递增索引
 * @return {*}
 */
function setProjectInfo(planGroups, projectIndex = 0) {
  const planList = []
  for (let j = 0; j < planGroups.length; j++) {
    projectIndex = projectIndex + 1

    // 同项目下的计划的项目名称必须相同，不同的项目使用projectIndex递增
    const group = planGroups[j].map((item) => {
      const name = item.plan.project_name
      const permanent_plan_name = `${name}_${projectIndex}`
      const project_name = replaceDynamicValue(name, item.target.name, item.ad_account_simple_name).concat(`_${projectIndex}`)
      return {
        ...item,
        plan: {
          ...item.plan,
          project_name
        },
        // 保存广告名称，不会跟随批量预览时修改变化，作为当前计划的永久标记
        permanent_plan_name
      }
    })

    for (let k = 0; k < group.length; k++) {
      const plan = clone(group[k])

      planList.push({ ...plan })
    }
  }

  return planList
}

/**
 * @description: 动态词替换
 * @param {*} name
 * @param {*} targetingName
 * @param {*} adAccountSimpleName
 * @return {*}
 */
function replaceDynamicValue(name, targetingName, adAccountSimpleName) {
  const replaceDynamicName = name.replace(/{(.*?)}/g, (res) => {
    const dynamicWord = res.replace(/[{}]/g, '')
    let value = ''
    switch (dynamicWord) {
      case '日期':
        value = moment().format('MMDD')
        break
      case '时间':
        value = moment().format('HH:mm:ss')
        break
      case '定向包名':
        value = targetingName
        break
      case '账号简称':
        value = adAccountSimpleName || ''
        break
      default:
        break
    }
    return value ? '_'.concat(value) : ''
  })
  return replaceDynamicName
}
